import { theme, rem } from '@nobia/zeus-components/lib/styled'

export default {
  colors: {
    text: '#666666',
    specialText: '#c2a471',
    grayText: '#666666',
  },
  typography: {
    pageTitle: {
      fontSize: rem(36),
      fontSizeDesktop: rem(36),
      fontWeight: '700',
      color: theme('colors.specialText'),
    },
    subHeadline: {
      fontSize: rem(14),
      fontSizeDesktop: rem(14),
      fontWeight: '500',
      letterSpacing: '2px',
      letterSpacingDesktop: '2px',
      color: theme('colors.specialText'),
    },
    pageDescription: {
      fontSize: rem(16),
      fontSizeDesktop: rem(16),
    },
    collectionLabel: {
      fontWeight: '400',
      fontSize: rem(16),
    },
    imageLabelText: {
      fontWeight: '300',
    },
    modalHeadline: {
      fontWeight: '400',
    },
  },
  mainContainer: {
    alignItems: 'flex-start',
  },
  headerContainer: {
    alignItems: 'flex-start',
    textAlign: 'left',
  },
}
